import { render, staticRenderFns } from "./Operat.vue?vue&type=template&id=c0a1796a&scoped=true&"
import script from "./Operat.vue?vue&type=script&lang=js&"
export * from "./Operat.vue?vue&type=script&lang=js&"
import style0 from "./Operat.vue?vue&type=style&index=0&id=c0a1796a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a1796a",
  null
  
)

export default component.exports